import { render, staticRenderFns } from "./Ad.vue?vue&type=template&id=f47a1ccc&scoped=true"
import script from "./Ad.vue?vue&type=script&lang=js"
export * from "./Ad.vue?vue&type=script&lang=js"
import style0 from "./Ad.vue?vue&type=style&index=0&id=f47a1ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47a1ccc",
  null
  
)

export default component.exports